// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export class DnaSyngoviaCardSectionDetailsModel {
  public i18nLabelPrefix = 'syngovia.label';
  public property = '';

  public constructor(defintion: Partial<DnaSyngoviaCardSectionDetailsModel>) {
    Object.assign(this, defintion);
  }

  get label(): string {
    return `${this.i18nLabelPrefix}.${this.property}`;
  }
}
